import style from "./login.module.css";
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux';
import * as Icon from "react-feather";
import { Form, Input, Button, Row, Col } from "antd";
import authenAction from '../../redux/action/authen-action';
import { useHistory } from 'react-router-dom';
import { Link } from 'react-router-dom';

const Login = () => {

  const history = useHistory();
  const dispatch = useDispatch();
  const isAuthenticate = useSelector(state => state.authenReducer.isAuthenticate);

  const [userAuthen, setUserAuthen] = useState({ username: '', userPassword: '' });

  useEffect(() => {
    if (isAuthenticate) {
      history.replace('/profile');
    }
  }, [isAuthenticate, history]);

  const onChangeText = (event) => {
    const { name, value } = event.target;
    setUserAuthen({ ...userAuthen, [name]: value });
  }

  const onFinish = (values) => {
    dispatch(authenAction.signIn(userAuthen));
  };

  const onFinishFailed = (errorInfo) => {
    //TODO:
  };

  return (
    <div className="bg-gray">
      <div className="container h-100">
        <Row className="center-screen">
          <Col xs={24} sm={24} md={18} lg={14} xl={14}>
            <div className={style.content_login}>
              <Row>
                <Col xs={0} sm={0} md={0} lg={8} xl={10}>
                  <div className={style.bg_login}>
                    <img src="/assets/logo-nmu.png" className="img-fluid" />
                  </div>
                </Col>
                <Col xs={24} sm={24} md={24} lg={14} xl={14}>
                  <div className={style.login_detail}>
                    <div className={style.logo_mobile}>
                      <img src="/assets/logo-nmu-list.png" />
                    </div>
                    <h3 style={{ fontWeight: "400" }}>
                      <span style={{ fontWeight: "800" }}>
                        <span className="color-primary">A</span>dmin
                      </span>
                      System
                    </h3>
                    <Form
                      name="basic"
                      layout="vertical"
                      className="my-3"
                      labelCol={{
                        span: 24,
                      }}
                      wrapperCol={{
                        span: 24,
                      }}
                      initialValues={{
                        remember: true,
                      }}
                      onFinish={onFinish}
                      onFinishFailed={onFinishFailed}
                    >
                      <Form.Item
                        label={<div className="d-flex"> <Icon.User className="me-1 color-primary" size={18} /> User </div>}
                        name="username"
                        rules={[
                          {
                            required: true,
                            message: "Please input your username!",
                          },
                        ]}
                      >
                        <Input className="w-100" name="username" value={userAuthen.username} onChange={onChangeText} />
                      </Form.Item>

                      <Form.Item
                        label={<div className="d-flex"><Icon.Lock className="me-1 color-primary" size={18} /> Password</div>}
                        name="password"
                        className="mb-0"
                        rules={[
                          {
                            required: true,
                            message: "Please input your password!",
                          },
                        ]}
                      >
                        <Input.Password name="userPassword" value={userAuthen.userPassword} onChange={onChangeText} className="w-100" />
                      </Form.Item>
                      <Form.Item
                        className="mb-2"
                      >
                        <span className="text-link">
                          <Link to="/ForgotPassword">
                            ลืมรหัสผ่าน
                          </Link>
                        </span>
                      </Form.Item>
                      <Form.Item
                        wrapperCol={{
                          span: 24,
                        }}
                      >
                        <Button type="primary" htmlType="submit" disabled={!userAuthen.username || !userAuthen.userPassword}>
                          Sign In
                        </Button>
                      </Form.Item>
                      {/* <div className="d-flex  align-items-center">
                        <span className="me-1 text-gray ">Login with</span> <div className="button-google"><img src="/assets/google-icon.jpg" className="img-fluid" /></div>
                      </div> */}
                    </Form>
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Login;
